import React, { Fragment } from 'react'
import { Container, Col, Row, Button, Card, CardBody, Input } from 'reactstrap';
import { ModalBacterium } from '../../../components/micro/bacterium/ModalBacterium';
import { useBacterium } from '../../../hooks/micro/useBacterium';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DialogBacterAntibiograms } from './DialogBacterAntibiograms';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';

export const IndexBacter = () => {

    const {
        bacteriums, method, validaciones,
        bacterium, gram, id_mic_morphology, morphologys, antibiograms, antibiogramsSelected, onChangeAntibiogram,
        handleInputChange, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage, handleSearch,
        stainGrams, id_mic_stain_gram,
        closeAntibiogramsDialog, openAntibiogramsDialog, modalAntibiograms, antibiogramsSelectedTable,
        closeDialog, openDialog, modalTitle, modal, modalAlert, closeDeleteAlert, showDeleteAlert,
        searchBacterium, handleClearBacterium, handleExportExcelBacterium, loadingExport
    } = useBacterium();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>

                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_mic_bacterium)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}

                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(rowData.id_mic_bacterium)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };


    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Row>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                        <Card>
                            <CardBody className="p-1">
                                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                                    <TitleDataTable
                                        titleTable="Listado de bacterias"
                                        buttonActions={handleExportExcelBacterium}
                                        titleButton="Listado de Bacterias"
                                        isDisbled={loadingExport}
                                        loadingIsDisabled={loadingExport}
                                        titleCreate="Crear Laboratorio"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearch}
                                        valueFilter={searchBacterium}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearBacterium}

                                    />
                                </Col>

                                <div className="table-responsive">
                                    <DataTable
                                        value={bacteriums}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="bacterium" header="Bacteria" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="label_mic_stain_gram" header="Gram" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="name_morphology" header="Morfologia" headerStyle={headerStyle} style={cellStyle} />

                                        <Column
                                            header="No. Antibiogramas"
                                            body={(rowData) => {
                                                const total = rowData.antibiograms ? rowData.antibiograms.length : 0;
                                                return (
                                                    <span
                                                        onClick={() => openAntibiogramsDialog(rowData)}
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#fff",
                                                            backgroundColor: "#25acd4ff",
                                                            padding: "4px 8px",
                                                            borderRadius: "12px",
                                                            fontSize: "10px",
                                                            display: "inline-block",
                                                            fontWeight: "bold"
                                                        }}
                                                        title="Ver antibiogramas"
                                                    >
                                                        {total} {total === 1 ? "Antibiograma" : "Antibiogramas"}
                                                    </span>
                                                );
                                            }}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />


                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />

                                    </DataTable>
                                </div>
                                <br />
                                <br />
                            </CardBody>
                        </Card>


                        {showDeleteAlert && (
                            <AlertDataTable
                                titleAlert="Eliminar Bacteria"
                                visibleAlert={modalAlert}
                                onHideAlert={closeDeleteAlert}
                                sizeAlert="medium-dialog delete-method"
                                messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar la bacteria?"
                                alert1={true}
                                titleAlert1={bacterium}
                                buttonAcept
                                titleNotLoading="Eliminar"
                                titleDanger="Cancelar"
                                actionAcept={saveDelete}
                                maskClassName="custom-total-mask"
                                newDesingDialog={true}
                                iconNewDialog="fa fa-trash-o f-20"
                                headerColor="#8b0000"
                                newDesingDialogDelete={true}
                                closable={false}

                            />

                        )}

                        <ModalBacterium
                            {...{
                                validaciones,
                                bacterium, gram, id_mic_morphology, morphologys, antibiograms, antibiogramsSelected, onChangeAntibiogram,
                                handleInputChange, loading,
                                saveCreate, saveUpdate, saveDelete, stainGrams, id_mic_stain_gram,
                                modal, closeDialog, openDialog, modalTitle, method, modalAlert, showDeleteAlert
                            }}
                        />

                        <DialogBacterAntibiograms
                            {...{
                                closeAntibiogramsDialog, openAntibiogramsDialog, modalAntibiograms, antibiogramsSelectedTable

                            }}
                        />
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}
